import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Card, CardBody, Col, Container, Row, Alert } from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

// Import actions
import { getsubmittedparticipants } from "store/rounds/actions";
import "assets/scss/table.scss";

class ResultParticipantlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameFilter: "",
      districtFilter: "",
      cityFilter: "",
      provinceFilter: "",
      idFilter: "",
      editFilter: "",
      reportFilter: "",
      selectedCheckboxes: {}, // Track checked checkboxes
      tableKey: 0,
      RoundParticipantlist: [],
      feedbackMessage: "",
      organization_name: "",
      errorMessage: "", // State for error message
      feedbackListColumns: [
        // {
        //   text: "ID",
        //   dataField: "id",
        //   sort: true,
        //   headerFormatter: (column, colIndex) => (
        //     <>
        //       <div>
        //         <input
        //           type="text"
        //           value={this.state.idFilter}
        //           onChange={(e) => this.handleFilterChange("idFilter", e)}
        //           className="form-control"
        //         />
        //       </div>
        //       <div>{column.text}</div>
        //     </>
        //   ),
        //   headerStyle: { width: "100px" },
        //   style: { width: "100px" },
        // },
        {
          dataField: "name",
          text: "Participants",
          sort: true,
          formatter: (cell, row) =>
            typeof cell === "string" ? cell : "Unknown", // Fallback for invalid data
          headerFormatter: (column, colIndex) => (
            <>
              <div>
                <input
                  type="text"
                  value={this.state.nameFilter}
                  onChange={e => this.handleFilterChange("nameFilter", e)}
                  className="form-control"
                />
              </div>
              <div>{column.text}</div>
            </>
          ),
          headerAlign: "center",
          align: "Left",
        },
        {
          dataField: "city",
          text: "City",
          sort: true,
          formatter: (cell, row) =>
            typeof cell === "string" ? cell : "Unknown", // Fallback for invalid data
          headerFormatter: (column, colIndex) => (
            <>
              <div>
                <input
                  type="text"
                  value={this.state.cityFilter}
                  onChange={e => this.handleFilterChange("cityFilter", e)}
                  className="form-control"
                />
              </div>
              <div>{column.text}</div>
            </>
          ),
          headerAlign: "center",
          align: "Left",
        },
        // Inside District column formatter
        {
          dataField: "district",
          text: "District",
          sort: true,
          formatter: (cell, row) => {
            return typeof cell === "string" ? cell : "Unknown";
          },
          headerFormatter: (column, colIndex) => (
            <>
              <div>
                <input
                  type="text"
                  value={this.state.districtFilter}
                  onChange={e => this.handleFilterChange("districtFilter", e)}
                  className="form-control"
                />
              </div>
              <div>{column.text}</div>
            </>
          ),
          headerAlign: "center",
          align: "Left",
        },
        {
          dataField: "province",
          text: "Province",
          sort: true,
          formatter: (cell, row) => {
            return typeof cell === "string" ? cell : "Unknown";
          },
          headerFormatter: (column, colIndex) => (
            <>
              <div>
                <input
                  type="text"
                  value={this.state.provinceFilter}
                  onChange={e => this.handleFilterChange("provinceFilter", e)}
                  className="form-control"
                />
              </div>
              <div>{column.text}</div>
            </>
          ),
          headerAlign: "center",
          align: "Left",
        },
        {
          dataField: "actions",
          text: "Actions",
          sort: false,
          formatter: (cell, round) => {
            const labId = round.lab?.id || round.lab_id || round.id;
            const participantId = round.id;
            const roundId = this.props.match.params.id;

            // ✅ Safely read organization name
            const organizationName =
              round.organization_name ||
              this.props.match?.params?.organization_name ||
              this.state.organization_name ||
              "org"; // fallback placeholder

            const schemeType =
              round.scheme_type ||
              round.scheme?.scheme_type ||
              this.props.roundDetails?.scheme_type;

            const roundStatus =
              round.status || this.props.roundDetails?.status || "";

            let reportPath = null;
            if (schemeType === "Quantitative") {
              reportPath = `/${organizationName}/${roundId}/${participantId}/reg_report1_view`;
            } else if (schemeType === "Qualitative") {
              reportPath = `/${organizationName}/${roundId}/${participantId}/reg_qualitative_report`;
            } else if (schemeType === "Identification") {
              reportPath = `/${organizationName}/${roundId}/${participantId}/reg_micro_report`;
            }

            // ✅ Ensure correct link
            let updatePath = `/${organizationName}/UpdateParticipantsResults/${roundId}?participantID=${labId}`;
            if (schemeType === "Identification") {
              updatePath = `/${organizationName}/update_microresult/${roundId}?participantID=${labId}`;
            }

            // ✅ NEW — Abrogate path: same page as Update, opened in abrogate mode.
            // Identification (micro) uses a different update component, so it is skipped.
            let abrogatePath = null;
            if (schemeType !== "Identification") {
              abrogatePath = `${updatePath}&mode=abrogate`;
            }

            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                }}
              >
                <Link
                  to={updatePath}
                  className="fas fa-edit text-success"
                  title="Edit Participant Result"
                />
                {/* ✅ NEW — Abrogate icon */}
                {abrogatePath && (
                  <Link
                    to={abrogatePath}
                    className="fas fa-ban text-danger"
                    title="Abrogate Participant Results"
                  />
                )}
                {reportPath && roundStatus === "Report Available" ? (
                  <Link
                    to={reportPath}
                    className="fas fa-file-alt text-primary"
                    title="View Report"
                  />
                ) : (
                  <span style={{ color: "red" }}>No Report</span>
                )}
              </div>
            );
          },
          headerAlign: "center",
          align: "center",
        },
      ],
    };
    this.transformParticipantData = this.transformParticipantData.bind(this);
  }

  // Transformation logic for participant data
  transformParticipantData(participantList) {
    return participantList.map(participant => ({
      ...participant,
      fullName: `${participant.firstName || "Unknown"} ${
        participant.lastName || ""
      }`,
    }));
  }

  componentDidMount() {
    this.fetchData();
    const { organization_name } = this.props.match.params;

    // Only set state if organization_name is empty
    if (!this.state.organization_name) {
      this.setState({ organization_name });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.RoundParticipantlist !== this.props.RoundParticipantlist) {
      this.setState({ RoundParticipantlist: this.props.RoundParticipantlist });
    }
  }

  fetchData = async () => {
    const { ongetsubmittedparticipants } = this.props;
    const RoundParticipantId = this.props.match.params?.id;

    if (!RoundParticipantId) {
      return;
    }

    // Inside fetchData after fetching participants
    try {
      await ongetsubmittedparticipants(RoundParticipantId);

      const updatedList = this.props.RoundParticipantlist;
      if (Array.isArray(updatedList)) {
        // 👀 Check if district is present in any participant
        updatedList.forEach((p, i) => {});

        this.setState({ RoundParticipantlist: updatedList });
      }
    } catch (error) {}
  };

  handleFilterChange = (filterName, e) => {
    this.setState({ [filterName]: e.target.value });
  };

  filterData = () => {
    const {
      RoundParticipantlist,
      nameFilter,
      districtFilter,
      idFilter,
      cityFilter,
      provinceFilter,
      editFilter,
      reportFilter,
    } = this.state;

    if (!Array.isArray(RoundParticipantlist)) {
      return [];
    }
    // Inside filterData
    return RoundParticipantlist.filter(entry => {
      const name =
        typeof entry.name === "string" ? entry.name.toLowerCase() : "";
      const id = entry.id ? entry.id.toString() : "";
      const district =
        typeof entry.district === "string" ? entry.district.toLowerCase() : "";
      const city =
        typeof entry.city === "string" ? entry.city.toLowerCase() : "";
      const province =
        typeof entry.province === "string" ? entry.province.toLowerCase() : "";
      const editValue =
        typeof entry.edit === "string" ? entry.edit.toLowerCase() : "";

      return (
        name.includes(nameFilter.toLowerCase()) &&
        district.includes(districtFilter.toLowerCase()) &&
        id.includes(idFilter) &&
        // ✅ FIX — city/province filters are now case-insensitive like name/district
        city.includes(cityFilter.toLowerCase()) &&
        province.includes(provinceFilter.toLowerCase()) &&
        editValue.includes(editFilter.toLowerCase()) &&
        reportFilter.includes(reportFilter.toLowerCase())
      );
    });
  };

  render() {
    const { RoundParticipantlist, roundDetails } = this.props;

    const defaultSorted = [{ dataField: "id", order: "desc" }];

    // Use roundDetails for breadcrumb
    const formatDate = date => {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    };

    const breadcrumbItem = roundDetails
      ? `Round Number: ${roundDetails.rounds || "No Round Number"}, 
         Scheme Name: ${roundDetails.scheme_name || "No Scheme Name"}, 
         Round Number: ${roundDetails.rounds || "No Round Number"}, 
         Cycle Number: ${roundDetails.cycle_no || "No Cycle Number"}, 
         Cycle Start Date: ${
           formatDate(roundDetails.issue_date) || "No Start Date"
         }, 
         Cycle End Date: ${
           formatDate(roundDetails.closing_date) || "No End Date"
         }, 
         Round Start Date: ${
           roundDetails.round_start_to_end
             ? formatDate(roundDetails.round_start_to_end.split(" to ")[0])
             : "No Round Start Date"
         }, 
         Round End Date: ${
           roundDetails.round_start_to_end
             ? formatDate(roundDetails.round_start_to_end.split(" to ")[1])
             : "No Round End Date"
         }`
      : "No Data Available";

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Database Admin | Round Participant List</title>
          </MetaTags>
          <Container fluid>
            {/* <Breadcrumbs title="List" breadcrumbItem="Round Participant List" /> */}

            {roundDetails ? (
              <div className="round-details">
                <h4 className="text-primary text-center">
                  List of Participants Who Submit Results for This Round
                </h4>

                <h4>Round Details:</h4>
                <p className="round-details-text">
                  {/* Display round details */}
                  <span className="me-3">
                    Scheme Name:{" "}
                    <strong style={{ color: "blue" }}>
                      {roundDetails.scheme_name || "No Scheme Name"}
                    </strong>
                  </span>
                  <span className="me-3">
                    Cycle Number:{" "}
                    <strong style={{ color: "blue" }}>
                      {roundDetails.cycle_no || "No Cycle Number"}
                    </strong>
                  </span>
                  <span className="me-3">
                    Round Number:{" "}
                    <strong style={{ color: "blue" }}>
                      {roundDetails.rounds || "No Round Number"}
                    </strong>
                  </span>
                  <span className="me-3">
                    Cycle Start Date:{" "}
                    <strong style={{ color: "blue" }}>
                      {formatDate(roundDetails.issue_date) || "No Start Date"}
                    </strong>
                  </span>
                  <span className="me-3">
                    Cycle End Date:{" "}
                    <strong style={{ color: "blue" }}>
                      {formatDate(roundDetails.closing_date) || "No End Date"}
                    </strong>
                  </span>
                  <span className="me-3">
                    Round Start Date:{" "}
                    <strong style={{ color: "blue" }}>
                      {roundDetails.round_start_to_end
                        ? formatDate(
                            roundDetails.round_start_to_end.split(" to ")[0]
                          )
                        : "No Round Start Date"}
                    </strong>
                  </span>
                  <span className="me-3">
                    Round End Date:{" "}
                    <strong style={{ color: "blue" }}>
                      {roundDetails.round_start_to_end
                        ? formatDate(
                            roundDetails.round_start_to_end.split(" to ")[1]
                          )
                        : "No Round End Date"}
                    </strong>
                  </span>
                </p>
              </div>
            ) : (
              <div>No round details available.</div>
            )}

            <Row className="justify-content-center">
              <Col xs="12">
                <Card>
                  <CardBody>
                    <ToolkitProvider
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={this.filterData()}
                      search
                    >
                      {toolkitprops => (
                        <React.Fragment>
                          <Row className="mb-4">
                            <Col xl="12">
                              <div
                                className="table-responsive"
                                style={{ overflowX: "auto" }}
                              >
                                <BootstrapTable
                                  key={this.state.tableKey}
                                  {...toolkitprops.baseProps}
                                  defaultSorted={defaultSorted}
                                  classes={"table align-middle table-hover"}
                                  bordered={false}
                                  striped={true}
                                  headerWrapperClasses={"table-light"}
                                  responsive
                                  data={this.filterData()} // Use Redux data directly
                                  columns={this.state.feedbackListColumns}
                                />
                              </div>
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ResultParticipantlist.propTypes = {
  match: PropTypes.object,
  RoundParticipantlist: PropTypes.array,
  roundDetails: PropTypes.object,
  history: PropTypes.object,
  ongetsubmittedparticipants: PropTypes.func,
  scheme_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  Report: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    roundDetails: state.RoundList?.roundDetails || {},
    RoundParticipantlist: state.RoundList?.RoundParticipantlist || [],
  };
};

const mapDispatchToProps = dispatch => ({
  ongetsubmittedparticipants: id => dispatch(getsubmittedparticipants(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResultParticipantlist));
